import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { createApiSlice } from "@common/common-slice/commonSlice";
import { timeoutCall } from "@common";

import {
  CRUD_QUESTION_BANK,
  GENERATE_QUESTIONS_FOR_QUESTION_BANK,
  GET_QUESTION_BANK_DETAILS,
  GET_QUESTION_STATUS_HISTORY,
  DOWNLOAD_QUESTION_BANK_TEMPLATE,
  DOWNLOAD_QUESTION_BANK,
  STORE_GEN_QUESTIONS_FOR_QUESTION_BANK,
  UPLOAD_QUESTION_BANK,
} from "@routes";

const apiConfig = [
  {
    name: "createQuestionBank",
    method: "post",
    url: CRUD_QUESTION_BANK,
    stateKey: "message",
  },
  {
    name: "getQuestionBank",
    method: "get",
    url: CRUD_QUESTION_BANK,
    stateKey: "data",
  },
  {
    name: "getQuestionBankDetails",
    method: "get",
    url: GET_QUESTION_BANK_DETAILS,
    stateKey: "detailsData",
  },
  {
    name: "getQuestionBankStatusHistory",
    method: "get",
    url: GET_QUESTION_STATUS_HISTORY,
    stateKey: "statusHistoryData",
  },
  {
    name: "generateQuestionsForQuestionBank",
    method: "post",
    url: GENERATE_QUESTIONS_FOR_QUESTION_BANK,
    stateKey: "generatedQuestionsData",
    loadingKey: "generateLoading",
  },
  {
    name: "storeGeneratedQuestionsForQuestionBank",
    method: "post",
    url: STORE_GEN_QUESTIONS_FOR_QUESTION_BANK,
    stateKey: "message",
  },
  {
    name: "updateQuestionBankPatch",
    method: "patch",
    url: CRUD_QUESTION_BANK,
    stateKey: "message",
  },
  {
    name: "updateQuestionBank",
    method: "put",
    url: CRUD_QUESTION_BANK,
    stateKey: "message",
  },
  {
    name: "deleteQuestionBank",
    method: "delete",
    url: CRUD_QUESTION_BANK,
    stateKey: "message",
  },
];

export const downloadQuestionBankTemplate = createAsyncThunk(
  "questionBank/downloadQuestionBankTemplate",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      await axios.get(DOWNLOAD_QUESTION_BANK_TEMPLATE, {
        params: data,
        withCredentials: true,
        responseType: "blob",
      })
        .then((res) => {
          const url = globalThis.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = url;

          link.setAttribute("download", "QuestionBankTemplate.xlsx");

          document.body.appendChild(link);

          link.click();
        });
    } catch (err) {
      resetFunction(dispatch);
      return rejectWithValue(err.response);
    }
  }
);

export const downloadQuestionBank = createAsyncThunk(
  "questionBank/downloadQuestionBankTemplate",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      await axios.get(DOWNLOAD_QUESTION_BANK, {
        params: data,
        withCredentials: true,
        responseType: "blob",
      })
        .then((res) => {
          const url = globalThis.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = url;

          link.setAttribute("download", "QuestionBank.xlsx");

          document.body.appendChild(link);

          link.click();
        });
    } catch (err) {
      resetFunction(dispatch);
      return rejectWithValue(err.response);
    }
  }
);

export const uploadQuestionBank = createAsyncThunk(
  "questionBank/uploadQuestionBank",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(UPLOAD_QUESTION_BANK, data, {
        withCredentials: true,
      });
      resetFunction(dispatch);
      return response;
    } catch (err) {
      resetFunction(dispatch);
      return rejectWithValue(err.response.data);
    }
  }
);

const customReducers = {
  initialState: {
    detailsData: [],
    statusHistoryData: [],
    generatedQuestionsData: [],
    generateLoading: false,
    backlogLoading: false,
  },

  reducers: {
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "questionBank",
  apiConfig,
  customReducers,
);

const questionBankSlice = slice;

export default questionBankSlice.reducer;

export const {
  createQuestionBank,
  getQuestionBank,
  getQuestionBankDetails,
  getQuestionBankStatusHistory,
  generateQuestionsForQuestionBank,
  storeGeneratedQuestionsForQuestionBank,
  updateQuestionBankPatch,
  updateQuestionBank,
  deleteQuestionBank,
} = thunks;

export const {
  resetMessage,
  resetErrMessage,
  rowSelect,
} = actions;

const resetFunction = (dispatch) => {
  timeoutCall(() => {
    dispatch(resetMessage());
    dispatch(resetErrMessage());
  });
};
